module.exports = __webpack_public_path__ + "static/rx-keyboard-d96ed4e0b251c4eab6e8138255da0ffc.jpg";